module.exports = __webpack_public_path__ + "static/media/college-2.b75d2ed8.jpeg";